export class ActivityLogChange {
  field: string = null
  from: string = null
  to: string = null

  constructor (init?: Partial<ActivityLogChange>) {
    Object.assign(this, init)
  }
}
